module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25.5 6a.5.5 0 01.5.5V24a2 2 0 01-2 2H8a2 2 0 01-2-2V6.5a.5.5 0 01.5-.5zM24 11.999H8V23.5a.5.5 0 00.5.5h15a.5.5 0 00.5-.5zm-3.403 2.528l.707.707a.5.5 0 010 .707l-5.298 5.298a2 2 0 01-2.828 0l-2.122-2.121-.352-.35a.5.5 0 01-.005-.707l.71-.71a.5.5 0 01.704-.002l2.125 2.123a.5.5 0 00.707 0l4.945-4.945a.5.5 0 01.707 0zM24 8H8v1.999h16z\" fill=\"#3d3d3d\" class=\"asda-icon__draw\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./common/components/icon/system/asda-events.svg
// module id = 686
// module chunks = 0